import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { sizeGuidesApi } from "./api";
import { productKeys } from "../products/hooks";

export const sizeGuideKeys = { all: ["size-guides"] as const };

export function useSizeGuides(active?: boolean) {
  return useQuery({
    queryKey: [...sizeGuideKeys.all, { active }],
    queryFn: () => sizeGuidesApi.list(active),
  });
}

export function useCreateSizeGuide() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: sizeGuidesApi.create,
    onSuccess: () => client.invalidateQueries({ queryKey: sizeGuideKeys.all }),
  });
}

export function useUpdateSizeGuide() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: Partial<{ name: string; values: string[]; active: boolean }> }) =>
      sizeGuidesApi.update(id, body),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: sizeGuideKeys.all });
      client.invalidateQueries({ queryKey: productKeys.all });
    },
  });
}
